import type { ExtractPropTypes } from 'vue'

import type Tag from './tag.vue'

import { buildProps, definePropType } from '@ll-plus/utils'
import { IconProps } from '../../icon'

// 方形 / 圆角 / 胶囊 / 树叶
export type tagShapeType = 'square' | 'round' | 'capsule' | 'leaf'

// props
export const tagProps = buildProps({
  label: {
    type: String,
    default: '',
  },
  // 标签形状
  shape: {
    type: String as () => tagShapeType,
    default: 'square',
  },
  // 图标
  icon: {
    type: definePropType<IconProps>(Object),
    default: () => ({
      iconName: '',
      color: undefined,
      size: undefined,
    }),
  },

  // 图标方位 left | right
  iconDirection: {
    type: String,
    default: 'left',
  },
} as const)

export type TagProps = ExtractPropTypes<typeof tagProps>

export type TagInstance = InstanceType<typeof Tag>
